import { isJSXElement } from "@utils/common";
import React from "react";

interface FeaturesList {
    item: string | JSX.Element;
    subItems?: string[];
}

export interface Feature {
    title: string;
    subTitle?: string;
    featuresList: FeaturesList[];
}

interface AlternativeFeatureProps {
    featuresData: Feature;
}

const AlternativeFeature: React.FC<AlternativeFeatureProps> = ({ featuresData }) => {
    return (
        <div className="pt-8">
            <p className="text-2xl font-medium pb-4">{featuresData.title}</p>
            {featuresData.subTitle && <p className="text-xl pb-2">{featuresData.subTitle}</p>}
            <ul>
                {featuresData.featuresList.map(({ item, subItems }, index) =>
                    isJSXElement(item) ? (
                        <React.Fragment key={index}>{item}</React.Fragment>
                    ) : (
                        <li key={index} className="text-lg">
                            {item}
                            {subItems && (
                                <ul className="pl-6 text-base">
                                    {subItems.map((subItem, subIndex) => (
                                        <li key={subIndex}>{subItem}</li>
                                    ))}
                                </ul>
                            )}
                        </li>
                    )
                )}
            </ul>
        </div>
    );
};

export default AlternativeFeature;
